export default __webpack_public_path__ + "static/media/logo-sign.858abe56.svg";